window.addEventListener("load", () => {
  /* -------------------------------
   * Helpers
   * ----------------------------- */
  function updateColorVariantCount(el) {
    if (el.dataset.countUpdated) return;
    el.dataset.countUpdated = "true";
    const values = (el.textContent || "").split("|");
    if (values.length > 1) {
      el.textContent = `Colors +${values.length - 1}`;
      el.style.opacity = 1;
    } else {
      el.textContent = "";
    }
  }

  function wrapDivsWithAnchor() {
    document.querySelectorAll(".nosto-image-container").forEach(container => {
      if (container.closest("a")) return; // already wrapped
      const url = container.getAttribute("product-url");
      if (url) {
        const a = document.createElement("a");
        a.href = url;
        container.parentNode.insertBefore(a, container);
        a.appendChild(container);
      }
    });
  }

  /* -------------------------------
   * Flickity
   * ----------------------------- */
function initSlider(slider, opts = {}) {
  if (!slider || Flickity.data(slider)) return;

  function tryInit(attempts = 0) {
    const items = slider.querySelectorAll(".nosto-list-item");
    const hasItems = items.length > 0;
    const hasHeight = slider.offsetHeight > 0 || (items[0] && items[0].offsetHeight > 0);

    if (hasItems && hasHeight) {
      slider.style.visibility = "hidden";

      const flkty = new Flickity(slider, Object.assign({
        cellAlign: "left",
        contain: true,
        prevNextButtons: true,
        pageDots: false
      }, opts));

      requestAnimationFrame(() => {
        flkty.resize();
        flkty.reposition();
        slider.style.visibility = "visible";
      });

      console.log("✅ Init slider:", slider.className);
    } else if (attempts < 50) {
      // retry until it's actually rendered (max ~2s)
      setTimeout(() => tryInit(attempts + 1), 100);
    } else {
      console.warn("⚠️ Slider never became visible:", slider.className);
    }
  }

  tryInit();
}



  /* -------------------------------
   * Wishlist
   * ----------------------------- */
  function handleWishListClick(evt) {
    evt.preventDefault();
    const btn = evt.currentTarget;
    const product = btn.closest(".nosto-list-item");
    if (!product) return;

    const obj = {
      epi: product.dataset.variantId,
      du: product.dataset.productUrl,
      empi: product.dataset.productId,
      iu: product.dataset.productImageUrl
    };

    const isSaved = btn.classList.toggle("is-saved");
    window._swat[isSaved ? "addToWishList" : "removeFromWishList"](obj, () => {
      theme.updateWishList();
    });
  }

  function initWishlistButtons(scope = document) {
    scope.querySelectorAll(".wishlist").forEach(btn => {
      if (btn.dataset.wishlistInit) return;
      const { empi, epi } = btn.dataset;
      if (window.myWishList) {
        const match = window.myWishList.find(i => i.empi == empi || i.epi == epi);
        if (match) btn.classList.add("is-saved");
      }
      btn.addEventListener("click", handleWishListClick);
      btn.dataset.wishlistInit = "true";
    });
  }

  /* -------------------------------
   * Cart Drawer
   * ----------------------------- */
  function initCartATC(scope = document) {
    scope.querySelectorAll(".nosto-list-item .atc-cart-nosto, .nosto-list-item .atc-cart-nosto span").forEach(btn => {
      if (btn.dataset.atcInit) return;
      btn.addEventListener("click", evt => {
        evt.preventDefault();
        evt.stopPropagation();
        const product = btn.closest(".nosto-list-item");
        if (!product) return;

        if (btn.classList.contains("already-in-cart")) {
          document.querySelector(".js-drawer-open-cart")?.click();
        } else {

            // nostojs(function(api) {
            // var request = api.createRecommendationRequest();
            // document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
            //     request.addElements([element.id]); 
            // });
            // request.loadRecommendations();
            // });

          theme.SizeDrawer.open(evt, product.dataset.productHandle);
          document.querySelector(".js-drawer-open-cart")?.click();
        }
      });
      btn.dataset.atcInit = "true";
    });
  }

  function initCartSliders(cartDrawer) {
    const isOpen = cartDrawer.classList.contains("drawer--is-open");
    cartDrawer.querySelectorAll(".nosto-cart-el .nosto-list").forEach(slider => {
      const flkty = Flickity.data(slider);
      if (isOpen && !flkty) {
        initSlider(slider, { prevNextButtons: false });
        initCartATC(cartDrawer);
      } else if (!isOpen && flkty) {
        flkty.destroy();
      }
    });
  }

  /* -------------------------------
   * Observers
   * ----------------------------- */
  const nostoObserver = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches(".nosto-list")) {
          initSlider(node);
          node.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
          initWishlistButtons(node);
          initCartATC(node);
        } else {
          node.querySelectorAll(".nosto-list").forEach(initSlider);
          node.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
          initWishlistButtons(node);
          initCartATC(node);
        }
      });
    });
  });
  nostoObserver.observe(document.body, { childList: true, subtree: true });

  const cartDrawer = document.getElementById("CartDrawer");
  if (cartDrawer) {
    const cartObs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.type === "attributes" && m.attributeName === "class") {
          initCartSliders(cartDrawer);
        }
      });
    });
    cartObs.observe(cartDrawer, { attributes: true, childList: true, subtree: true });
  }

  /* -------------------------------
   * Init
   * ----------------------------- */
  wrapDivsWithAnchor();
  initWishlistButtons();
});
